export const EventHelperTypes = {
  LogOut: 'logout',
};

export const UtmSource = {
  FoodAmigosOCC: 'foodamigos_occ',
};

export const OrderMethod = {
  Pickup: 'pickup',
  Delivery: 'delivery',
  OnSite: 'on_site',
};

// @deprecated PROD-829: the on-site value backends sent before the on_site rename. Read-only
// compat (see OrderHelpers.isOnSite / canonicalMethod); never sent to the backend.
export const LegacyOrderMethod = {
  RoomService: 'room_service',
};

export const OrderFulfillmentStatus = {
  Created: 'created',
  Reviewed: 'reviewed',
  Accepted: 'accepted',
  Preparing: 'preparing',
  Ready: 'ready',
  OnDelivery: 'on_delivery',
  Picked: 'picked',
  Rejected: 'rejected',
};

export const OrdersPauseReason = {
  Manual: 'manual',
  Inactivity: 'inactivity',
};

export const OrderRejectionReason = {
  Automatic: 'auto',
  ClosingSoon: 'closing_soon',
  ItemUnavailable: 'item_unavailable',
  StoryBusy: 'store_busy',
  OrderTooBig: 'order_too_big',
  CustomerMistake: 'customer_mistake',
  DriverNotArrived: 'driver_not_arrived',
  Other: 'other',
};

export const RefundReason = {
  RequestedByCustomer: 'requested_by_customer',
  Reclamation: 'reclamation',
  CommunicationError: 'communication_error',
  Dispute: 'dispute',
  Other: 'other',
};

export const CouponType = {
  Reward: 1,
  Cashback: 2,
  PromoCode: 3,
  GiftCard: 4,
};

export const PaymentMethod = {
  Card: 'card',
  Paypal: 'paypal',
  ApplePay: 'apple_pay',
  GooglePay: 'google_pay',
  Sofort: 'sofort',
  Giropay: 'giropay',
  SepaDebit: 'sepa_debit',
  Cash: 'cash',
  BacsDebit: 'bacs_debit',
};

export const TaxBehavior = {
  Inclusive: 'inclusive',
  Exclusive: 'exclusive',
};

export const DeliveryMode = {
  Internal: 'internal',
  External: 'external',
};

export const DeliveryProvider = {
  Standalone: 'standalone',
  FirstDelivery: 'first_delivery',
  UberDrive: 'uber_drive',
  WoltDrive: 'wolt_drive',
};

export const DeliveryCarrier = {
  Uber: 'uber',
  Wolt: 'wolt',
};

export const DeliveryStatus = {
  Pending: 'pending',
  RunnerAssigned: 'runner_assigned',
  OnRoutePickup: 'en_route_pickup',
  ArrivedPickup: 'arrived_pickup',
  PickedUp: 'picked_up',
  OnRouteDropoff: 'en_route_dropoff',
  ArrivedDropoff: 'arrived_dropoff',
  Completed: 'completed',
  Cancelled: 'cancelled',
};

export const PickupTimeOptimizationStrategy = {
  WaitForFirstUpdate: 'wait_for_first_update',
  WaitForDriverAssignment: 'wait_for_driver_assignment',
};

// The backend sends `error_code` in snake_case.
export const BackendErrorCode = {
  NoDeliveryQuotesAvailable: 'no_delivery_quotes_available',
  DeliveryProviderException: 'delivery_provider_exception',
  DeliveryDispatchRetrying: 'delivery_dispatch_retrying',
};

export const DeliveryDispatchStatus = {
  Retrying: 'retrying',
  Failed: 'failed',
};

export const ModifierEntryType = Object.freeze({
  Product: 'product',
  Modifier: 'modifier',
});

export const OFFER_KIND = Object.freeze({
  PERCENTAGE_OFF_BY_PRODUCTS: 'percentage_off_by_products',
  PERCENTAGE_OFF_BY_MIN_SPEND_VALUE: 'percentage_off_by_min_spend_value',

  AMOUNT_OFF_BY_PRODUCTS: 'amount_off_by_products',
  AMOUNT_OFF_BY_MIN_SPEND_VALUE: 'amount_off_by_min_spend_value',

  FREE_ITEM_BY_PRODUCTS: 'free_item_by_products',
  FREE_ITEM_BY_MIN_SPEND_VALUE: 'free_item_by_min_spend_value',

  BOGO: 'bogo',
  BOGO_HALF_PRICE: 'bogo_half_price',
});

export const PaperSize = Object.freeze({
  Default: 384,
});

export const MinNativeVersion = Object.freeze({
  PrinterBridge: '0.1.0',
});

export const Destination = Object.freeze({
  Sunmi: 'sunmi',
  External: 'external',
});

// Mirrors ESC_PRINTER_STATUS in the native app — these values arrive over the webview
// bridge as `externalPrinterStatus` and drive presentation only, never print routing.
export const PrinterStatus = Object.freeze({
  Connected: 'CONNECTED',
  // Printable, but the roll is nearly out — `externalPrinterConnected` stays true.
  PaperNearEnd: 'PAPER_NEAR_END',
  NotConfigured: 'NOT_CONFIGURED',
  Offline: 'OFFLINE',
  Timeout: 'TIMEOUT',
  Unreachable: 'UNREACHABLE',
  Busy: 'BUSY',
  CoverOpen: 'COVER_OPEN',
  PaperEmpty: 'PAPER_EMPTY',
  WrongPaper: 'WRONG_PAPER',
  CutterError: 'CUTTER_ERROR',
  MechanicalError: 'MECHANICAL_ERROR',
  Overheat: 'OVERHEAT',
  Unrecoverable: 'UNRECOVERABLE',
  UnknownError: 'UNKNOWN_ERROR',
});
